<template>
  <input-base
      ref="input"
      :validated-field="validatedField"
      :field-config="fieldConfig"
      :read-only="readOnly"
      :editor-mode="editorMode"
  >
    <template slot="editor">
      <b-form-select
          :class="readOnly ? 'grey-label' : ''"
          :style="selectedDepartmentInfo ? 'text-indent:' + selectedDepartmentInfo.depth * -8.5 +'px' : ''"
          v-model="selectedDepartmentInfo"
          :options="choiceOfDepartmentsInfo"
          :disabled="readOnly"
      >
      </b-form-select>
    </template>

  </input-base>
</template>

<script>

import InputBase from "@/components/inputs/InputBase";

import FormValidatedField from "@/components/forms/FormValidatedField";
import TextListFormFieldConfig from "@/server/com/silkplm/engine/forms/schema/definition/TextListFormFieldConfig";
import Rpc from "@/Rpc";
import Department from "@/server/com/silkplm/model/users/Department";
import PermissionsSet from "@/server/PermissionsSet";
import FormFieldConfig from "@/server/com/silkplm/engine/forms/schema/definition/FormFieldConfig";

export default {
  name: "DepartmentRenderer",
  components: {InputBase},
  mounted(){
    this.loadChoiceOfDepartmentsList();
  },
  props:{
    validatedField: { type: FormValidatedField, required:true },
    fieldConfig: { type: FormFieldConfig, required:true },
    
  },

  methods:{
    setReadOnly(readOnly){
      this.readOnly = this.fieldConfig.readOnly || readOnly;
    },
    setEditorMode(val){
      this.editorMode = val;
    },

    async loadChoiceOfDepartmentsList() {
      let listOfDepartmentsInfo = await Rpc.organization.Departments.departmentsList();
      this.choiceOfDepartmentsInfo = [];
      if (this.department) {
        for (let i = 0; i < listOfDepartmentsInfo.length; i++) {
          if (listOfDepartmentsInfo[i].name !== this.department.name &&
              listOfDepartmentsInfo[i].department.parentId !== this.department.id) {
            this.choiceOfDepartmentsInfo.push(
                {
                  value: listOfDepartmentsInfo[i],
                  text: "\xa0".repeat(listOfDepartmentsInfo[i].depth * 2) + listOfDepartmentsInfo[i].name
                }
            );
          }
        }
        this.numberOfDepartments = this.choiceOfDepartmentsInfo.length;
      }
    },

  },

  data: () => ({
    readOnly: true,
    editorMode: false,
    numberOfDepartments: 0,
    selectedDepartmentInfo: new Department(),
    permissions: new PermissionsSet(),
    choiceOfDepartmentsInfo: [],
    department: new Department(),
    parentDepartment: new Department(),
  })
}
</script>

<style scoped>

</style>